import React from 'react'
import { withIcon } from '../../withIcon'

function CheckIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.0772 15.6069L18.4703 6.29033C18.8202 5.90322 19.3876 5.90322 19.7375 6.29033C20.0875 6.67744 20.0875 7.30507 19.7375 7.69218L10.7108 17.7097C10.3609 18.0968 9.79349 18.0968 9.44355 17.7097L4.26245 12.3428C3.91252 11.9557 3.91252 11.3281 4.26245 10.9409C4.61239 10.5538 5.17976 10.5538 5.5297 10.9409L10.0772 15.6069Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CheckIcon)
